import { parseInt } from 'lodash';
import { isJcpCardLinkedToRewards } from 'yoda-site-components/lib/helpers/Utils/utils.js';
import {
    PLCC_BANNER_CATID_INCLUSION_LIST,
    PLCC_BANNER_PRICE_THRESHHOLD,
    PLCC_BANNER_ALL_OTHER_THRESHHOLD_MSG,
    PLCC_BANNER_FOR_SPECIAL_FINANCING,
} from '../components/PLCCBanner/Config';

export const getMappedCategoryId = (productDetails) => {
    return productDetails?.category?.id;
};

export const showPLCCBanner = (plccMessage, specificThresholdValue, productPrice, preferences) => {
    const {
        plccBannerConfig: {
            priceThreshhold = PLCC_BANNER_PRICE_THRESHHOLD,
            specialfinancingcontent = PLCC_BANNER_FOR_SPECIAL_FINANCING,
        } = {},
    } = preferences;
    // check price threshold rule

    const threshholdToUse = specificThresholdValue || priceThreshhold;
    const formattedprice = productPrice?.replace(/\$|,/g, '');
    const isAbovePriceThreshhold =
        formattedprice && threshholdToUse && parseInt(formattedprice) > parseInt(threshholdToUse);
    const isWithinSpecificThreshold =
        formattedprice <= parseInt(specificThresholdValue) &&
        formattedprice > parseInt(priceThreshhold);
    const displayPLCCBanner =
        plccMessage &&
        plccMessage !== '' &&
        (plccMessage === specialfinancingcontent
            ? isAbovePriceThreshhold
            : isAbovePriceThreshhold || isWithinSpecificThreshold);

    return displayPLCCBanner;
};

export const getPLCCMessage = (mappedcatid, productPrice, preferences) => {
    const {
        plccBannerConfig: {
            inclusionCatIds = PLCC_BANNER_CATID_INCLUSION_LIST,
            otherCatContent = PLCC_BANNER_ALL_OTHER_THRESHHOLD_MSG,
            specialfinancingcontent = PLCC_BANNER_FOR_SPECIAL_FINANCING,
            priceThreshhold = PLCC_BANNER_PRICE_THRESHHOLD,
        } = {},
    } = preferences;

    const plccMessage = inclusionCatIds?.find((item) => item?.catIds?.includes(mappedcatid));
    /* istanbul ignore next */
    if (isJcpCardLinkedToRewards()) {
        if (plccMessage) {
            return specialfinancingcontent;
        }
        return '';
    }
    const specificThresholdValue = plccMessage ? plccMessage.threshhold : 0;
    if (productPrice <= specificThresholdValue && productPrice > priceThreshhold) {
        return plccMessage?.updatedcontent;
    }
    return plccMessage?.content || otherCatContent;
};
export const getSpecificThreshold = (mappedcatid, preferences) => {
    const {
        plccBannerConfig: { inclusionCatIds = PLCC_BANNER_CATID_INCLUSION_LIST } = {},
    } = preferences;

    const plccMessage = inclusionCatIds?.find((item) => item?.catIds?.includes(mappedcatid));
    const SpecificThreshhold = plccMessage ? plccMessage.threshhold : 0;

    return SpecificThreshhold;
};
